import { useGetCategoriesByProductTypeQuery } from "Services/CategoryApiSlice";
import { useGetAuthorsByCategoryQuery } from "Services/Admin/ActiveAuthorApiSlice";
import { useGetAllActiveAcademicsQuery } from "Services/Admin/ActiveAcademicApiSlice";
import { useGetActiveLanguagesByProductTypeQuery } from "Services/Admin/ActiveLanguageApiSlice";
import { useGetAllActiveMerchandisesQuery } from "Services/Admin/ActiveMerchandiseApiSlice";
import { Category } from "Types/Navbar";

const mapCategoryList = (data: any[]): Category[] =>
  (
    data?.map((cat) => {
      const actualSubs =
        cat.subClasses
          ?.filter((sub: any) => sub.subClassName && sub.subClassName.trim() !== "")
          ?.map((sub: any) => ({
            name: sub.subClassName as string,
            code: sub.subClassId,
          }))
          ?.filter(
            (sub: any, index: number, self: any[]) =>
              index === self.findIndex((s) => s.code === sub.code),
          ) || [];

      const subs = [{ name: "None", code: "None" }, ...actualSubs];

      return {
        name: cat.categoryName,
        code: cat.categoryId,
        subs,
        image: "",
        isActive: "1",
      };
    }) || []
  ).filter(
    (cat, index, self) => index === self.findIndex((c) => c.code === cat.code),
  );

export const useNavbarData = (hoveredCategoryName?: string | null) => {
  const { data: categoriesData, isLoading, error } = useGetCategoriesByProductTypeQuery("BOOK");
  const { data: recordCategoriesData } = useGetCategoriesByProductTypeQuery("RECORD");
  const { data: languagesData } = useGetActiveLanguagesByProductTypeQuery("BOOK");
  const { data: recordLanguagesData } = useGetActiveLanguagesByProductTypeQuery("RECORD");
  const { data: academicsData } = useGetAllActiveAcademicsQuery();
  const { data: merchandisesData } = useGetAllActiveMerchandisesQuery();
  const languages = Array.from(
    new Set([
      ...(languagesData?.map((lang) => lang.language) || []),
      ...(recordLanguagesData?.map((lang) => lang.language) || []),
    ]),
  );
  const academics = academicsData?.map((aca) => aca.academic) || [];
  const merchandises = merchandisesData?.map((merch) => merch.merchandise) || [];

  const mappedCategories: Category[] = mapCategoryList(categoriesData ?? []);
  const mappedRecordCategories: Category[] = mapCategoryList(recordCategoriesData ?? []);

  const hoveredCategoryCode =
    hoveredCategoryName
      ? mappedCategories.find((c) => c.name === hoveredCategoryName)?.code ?? null
      : null;

  const { data: authorsByCategory, isLoading: isAuthorsLoading } =
    useGetAuthorsByCategoryQuery(
      { categoryId: hoveredCategoryCode!, productType: "BOOK" },
      { skip: !hoveredCategoryCode },
    );

  const authors = authorsByCategory ?? [];

  return {
    mappedCategories,
    mappedRecordCategories,
    authors,
    isAuthorsLoading,
    languages,
    academics,
    merchandises,
    isLoading,
    error,
  };
};
